import React, { useEffect, useState } from "react"
import { FormControl, FormControlLabel, Switch } from "@material-ui/core"
import { DetailWrapperOqt } from "../";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const getFormikValue = (formik, name, defaultValue, props) => {
  const value = (formik && formik.values) ? (formik.values[name] ? formik.values[name] : (defaultValue && eval(defaultValue)())) : false;
  return value ? 1 : 0;
}

export const SwitchOqt = React.memo((props) => {
  const {defaultValue, details = false, name, caption, formik, initialState = null, title, readOnly = true, onChange, variant = "outlined"} = props;
  const [timer, setTimer] = useState(null);
  const [value, setValue] = useState(()=>getFormikValue(formik, name, defaultValue));
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    //console.log ({name, formikvalue: formik.values[name], initialState, props})
    setLoaded(true);
    return () => clearTimeout(timer);
  }, [])
  
  useEffect(()=>{
    timer !== null && clearTimeout(timer);
    setTimer( 
      formik ? setTimeout(actualizarFormik, 50) : onChange({target:{name, value: value}})
    );
  }, [value])

  const actualizarFormik = () => {
    formik.values && formik.values[name] !== value && formik.setFieldValue(name, value);
  }

  const handleInputChange = () => {
    setValue(value === 1 ? 0 : 1)
  }
  
  const classes = useStyles();

  if(details){
    return (
      <>
        <DetailWrapperOqt caption={caption}>{formik.values[name] ? "Sí" : "No"}</DetailWrapperOqt>
      </>
    )
  }

  return (
    <FormControl fullWidth  variant="outlined" className={classes.formControl} style={{margin:"4px 8px 4px 8px"}}>
      <FormControlLabel 
        control={
          <Switch
            title={title}
            variant="outlined"
            id={name}
            name={name}
            color="primary" 
            readOnly={readOnly}
            checked={value  === 1} 
            onChange={handleInputChange}
            value={value === 1}/>
        }
        label={variant === "outlined" && caption}
        labelPlacement="end"
      />
    </FormControl>
  )
})
